import { makeRoutePath } from '@hammam_dev/make-route-path';

export const ApiDirectory = {
  User: {
    AuthUser: makeRoutePath('api/User/authuser'),
    UserDetail: makeRoutePath('api/User/detail'),
    UsersVisibles: makeRoutePath('api/User/usersVisibles'),
    EliminarUsuario: makeRoutePath('api/User/:idHashCRM'),
    UpdateUser: makeRoutePath('api/User/updateUser'),
    ChangeImpersonalizedUser: makeRoutePath('api/User/changeImpersonalizedUser'),
    UpdateAccount: makeRoutePath('api/User/:userId'),
    UpdateUserAccess: makeRoutePath('api/User/accesos'),
    AddNewUser: makeRoutePath('api/User/addUser'),
    resetPassword: makeRoutePath('api/User/oneLogin/resetPassword'),
    emailWelcome: makeRoutePath('api/User/oneLogin/emailWelcome'),
    ProteccionDatos: makeRoutePath('api/User/protecciondatos'),
    IdiomaComunicacion: makeRoutePath('api/User/idiomaComunicacion'),
    DeleteFactors: makeRoutePath('api/User/oneLogin/factors'),
  },
  Home: {
    ServiciosContratados: makeRoutePath('api/Home/serviciosContratados'),
    UltimasFacturas: makeRoutePath('api/Home/ultimasFacturas'),
    SistemaArbitralDeConsumo: makeRoutePath('api/Home/SistemaArbitralDeConsumo'),
  },
  Maestros: {
    DescargarDocumento: makeRoutePath('api/Maestros/documento/:idDCTM'),
    DescargarDocumentos: makeRoutePath('api/Maestros/documentos'),
    Instalaciones: makeRoutePath('api/Maestros/instalaciones/user'),
    Sociedades: makeRoutePath('api/Maestros/socidedades/user'),
    TiposVias: makeRoutePath('api/Maestros/tiposVias'),
    PoblacionCodPostal: makeRoutePath('api/Maestros/poblacion/:postal'),
    AutoConcumos: makeRoutePath('api/Maestros/autoConsumos'),
    TipoCups: makeRoutePath('api/Maestros/tipoCups'),
    TipoSubsection: makeRoutePath('api/Maestros/tipoSubseccion'),
    TipoInstalacion: makeRoutePath('api/Maestros/tipoInstalacion'),
  },
  Mercado: {
    // OMIE
    OmieDiario: makeRoutePath('api/Mercado/datosOmie/diario'),
    OmieMensual: makeRoutePath('api/Mercado/datosOmie/mensual'),
    OmieAnual: makeRoutePath('api/Mercado/datosOmie/anual'),
    // OMIE EXCEL
    OmieDiarioExcel: makeRoutePath('api/Mercado/datosOmie/diario/excel'),
    OmieMensualExcel: makeRoutePath('api/Mercado/datosOmie/mensual/excel'),
    OmieAnualExcel: makeRoutePath('api/Mercado/datosOmie/anual/excel'),
    OmieHistoricoExcel: makeRoutePath('api/Mercado/datosOmie/historico/excel'),
    // OMIP
    OmipCurrent: makeRoutePath('api/Mercado/datosOmip/cotizaciones/actual'),
    OmipHistoric: makeRoutePath('api/Mercado/datosOmip/cotizaciones/historico'),
    // OMIP EXCEL
    OmipCurrentExcel: makeRoutePath('api/Mercado/datosOmip/cotizaciones/actual/excel'),
    OmipHistoricExcel: makeRoutePath('api/Mercado/datosOmip/cotizaciones/historico/excel'),
    // MERCADO TECNOLOGIA
    MercadoTecnologiaDiario: makeRoutePath('api/Mercado/datosMercadoTecnologia/diario'),
    MercadoTecnologiaMensual: makeRoutePath('api/Mercado/datosMercadoTecnologia/mensual'),
    MercadoTecnologiaAnual: makeRoutePath('api/Mercado/datosMercadoTecnologia/anual'),
    // MERCADO TECNOLOGIA EXCEL
    MercadoTecnologiaDiarioExcel: makeRoutePath('api/Mercado/costeMercadoTecnologico/diario/excel'),
    MercadoTecnologiaMensualExcel: makeRoutePath('api/Mercado/costeMercadoTecnologico/mensual/excel'),
    MercadoTecnologiaAnualExcel: makeRoutePath('api/Mercado/costeMercadoTecnologico/anual/excel'),
    // DEMANDA REAL
    DemandaRealDatos: makeRoutePath('api/Mercado/datosDemandaReal/:path'),
    DemandaRealExcel: makeRoutePath('api/Mercado/datosDemandaReal/:path/excel'),
  },
  CosteMercado: {
    // DESVIOS
    DesviosDatos: makeRoutePath('api/Mercado/costeMercadoDesvios/:path'),
    DesviosExcel: makeRoutePath('api/Mercado/costeMercadoDesvios/:path/excel'),
    // MATERIAS PRIMAS
    MateriasPrimasDatos: makeRoutePath('api/Mercado/materiasPrima/historico'),
    MateriasPrimasExcel: makeRoutePath('api/Mercado/materiasPrima/historico/excel'),
    // RESTRICCIONES
    RestriccionesDatos: makeRoutePath('api/Mercado/costeMercadoRestricciones/:path'),
    RestriccionesExcel: makeRoutePath('api/Mercado/costeMercadoRestricciones/:path/excel'),
    // PERDIDAS
    PerdidasDatos: makeRoutePath('api/Mercado/datosPerdida/:path'),
    PerdidasExcel: makeRoutePath('api/Mercado/datosPerdida/:path/excel'),
  },
  ServiciosContratados: {
    ProductosContratados: makeRoutePath('api/ServiciosContratados/productosContratados'),
    Sociedad: makeRoutePath('api/ServiciosContratados/sociedad/:idSociedad'),
    InstalacionesSociedad: makeRoutePath('api/ServiciosContratados/sociedad/:idSociedad/instalaciones'),
    Instalacion: makeRoutePath('api/ServiciosContratados/instalacion/:cups'),
    TramitesInstalacion: makeRoutePath('api/ServiciosContratados/instalacion/:cups/tramites'),
  },
  Tramites: {
    NuevoAdjunto: makeRoutePath('api/Tramites/borrador/adjunto'),
    EliminarAdjunto: makeRoutePath('api/Tramites/borrador/adjunto/:idFichero'),
    DescargarAdjunto: makeRoutePath('api/Tramites/borrador/adjunto/:idFichero'),
    EliminarBorrador: makeRoutePath('api/Tramites/borrador/:idBorrador'),
    // My-procedures Tabs List
    AllProcedures: makeRoutePath('api/Tramites/todas'),
    RequiredProcedures: makeRoutePath('api/Tramites/informacionRequerida'),
    PendingProcedures: makeRoutePath('api/Tramites/enTramite'),
    ClosedProcedures: makeRoutePath('api/Tramites/cerradas'),
    Drafts: makeRoutePath('api/Tramites/borradores'),
    // Cambio de ciclo
    PortugalDetalleCambioCiclo: makeRoutePath('api/Tramites/cambioCicloPt/:codTramite'),
    PortugalValidacionCambioCiclo: makeRoutePath('api/Tramites/validacion/cambioCicloPt/Cups/:cups'),
    PortugalNuevoTramiteCambioCiclo: makeRoutePath('api/Tramites/cambioCicloPt/:idBorrador'),
    PortugalDetalleBorradorCambioCiclo: makeRoutePath('api/Tramites/borrador/:idBorrador/cambioCicloPt'),
    PortugalNuevoBorradorCambioCiclo: makeRoutePath('api/Tramites/borrador/cambioCicloPt'),
    // Cambio de potencia
    DetallePotenciasTarifas: makeRoutePath('api/Tramites/potenciasTarifas/:codTramite'),
    ValidacionPotenciasTarifas: makeRoutePath('api/Tramites/validacion/potenciasTarifas/Cups/:cups'),
    NuevoTramitePotenciasTarifas: makeRoutePath('api/Tramites/potenciasTarifas/:idBorrador'),
    DetalleBorradorPotenciasTarifas: makeRoutePath('api/Tramites/borrador/:idBorrador/potenciasTarifas'),
    NuevoBorradorPotenciasTarifas: makeRoutePath('api/Tramites/borrador/potenciasTarifas'),
    PdfPotenciasTarifas: makeRoutePath('api/Tramites/borrador/:idBorrador/potenciasTarifas/pdf'),
    // Cambio de potencia Portugal
    PortugalDetallePotenciasTarifas: makeRoutePath('api/Tramites/potenciasPt/:codTramite'),
    PortugalValidacionPotenciasTarifas: makeRoutePath('api/Tramites/validacion/potenciasPt/Cups/:cups'),
    PortugalNuevoTramitePotenciasTarifas: makeRoutePath('api/Tramites/potenciasPt/:idBorrador'),
    PortugalDetalleBorradorPotenciasTarifas: makeRoutePath('api/Tramites/borrador/:idBorrador/potenciasPt'),
    PortugalNuevoBorradorPotenciasTarifas: makeRoutePath('api/Tramites/borrador/potenciasPt'),
    // Comunicación bidireccional
    BidirectionalComments: makeRoutePath('api/Tramites/comentarios/:codTramite'),
    BidirectionalFiles: makeRoutePath('api/Tramites/ficheros/:codTramite'),
    AddBidirectionalComment: makeRoutePath('api/Tramites/comentario'),
    AddBidirectionalFiles: makeRoutePath('api/Tramites/ficheros'),
    // Cambio de dirección de facturación
    ValidacionDireccionFacturacion: makeRoutePath('api/Tramites/validacion/direccionFacturacion/Cups/:cups'),
    NuevoTramiteDireccionFacturacion: makeRoutePath('api/Tramites/direccionFacturacion/:idBorrador'),
    DetalleBorradorDireccionFacturacion: makeRoutePath('api/Tramites/borrador/:idBorrador/direccionFacturacion'),
    NuevoBorradorDireccionFacturacion: makeRoutePath('api/Tramites/borrador/direccionFacturacion'),
    DetalleDireccionFacturacion: makeRoutePath('api/Tramites/direccionFacturacion/:codTramite'),
    // Aplazamiento de pagos
    AplazamientoPago: makeRoutePath('api/Tramites/aplazamientoPago/:codTramite'),
    ValidacionAplazamientoPagoa: makeRoutePath('api/Tramites/validacion/aplazamientoPago/Cups/:cups'),
    NuevoBorradorAplazamientoPago: makeRoutePath('api/Tramites/borrador/aplazamientoPago'),
    DetalleBorradorAplazamientoPago: makeRoutePath('api/Tramites/borrador/:idBorrador/aplazamientoPago'),
    NuevoTramiteAplazamientoPago: makeRoutePath('api/Tramites/aplazamientoPago/:idBorrador'),
    // Procedimientos
    ValidacionAveriaCalidadSuministro: makeRoutePath('api/Tramites/validacion/averias/Cups/:cups'),
    NuevoBorradorAveriaCalidadSuministro: makeRoutePath('api/Tramites/borrador/averias'),
    DetalleBorradorAveriaCalidadSuministro: makeRoutePath('api/Tramites/borrador/:idBorrador/averias'),
    NuevoTramiteAveriaCalidadSuministro: makeRoutePath('api/Tramites/averias/:idBorrador'),
    DetalleAveriaCalidadSuministro: makeRoutePath('api/Tramites/averias/:codTramite'),
    // averias portugal
    PortugalValidacionAveriaCalidadSuministro: makeRoutePath('api/Tramites/validacion/averiasPt/Cups/:cups'),
    PortugalNuevoBorradorAveriaCalidadSuministro: makeRoutePath('api/Tramites/borrador/averiasPt'),
    PortugalDetalleBorradorAveriaCalidadSuministro: makeRoutePath('api/Tramites/borrador/:idBorrador/averiasPt'),
    PortugalNuevoTramiteAveriaCalidadSuministro: makeRoutePath('api/Tramites/averiasPt/:idBorrador'),
    PortugalDetalleAveriaCalidadSuministro: makeRoutePath('api/Tramites/averiasPt/:codTramite'),
    // Información Concepto Factura
    DetalleInformacionConceptoFactura: makeRoutePath('api/Tramites/informacionConceptoFactura/:codTramite'),
    ValidacionInformacionConceptoFactura: makeRoutePath('api/Tramites/validacion/informacionConceptoFactura/Cups/:cups'),
    DetalleBorradorInformacionConceptoFactura: makeRoutePath('api/Tramites/borrador/:idBorrador/informacionConceptoFactura'),
    NuevoTramiteInformacionConceptoFactura: makeRoutePath('api/Tramites/informacionConceptoFactura/:idBorrador'),
    NuevoBorradorInformacionConceptoFactura: makeRoutePath('api/Tramites/borrador/informacionConceptoFactura'),
    // Información Concepto Factura
    PortugalDetalleInformacionConceptoFactura: makeRoutePath('api/Tramites/informacionConceptoFacturaPt/:codTramite'),
    PortugalValidacionInformacionConceptoFactura: makeRoutePath('api/Tramites/validacion/informacionConceptoFacturaPt/Cups/:cups'),
    PortugalDetalleBorradorInformacionConceptoFactura: makeRoutePath('api/Tramites/borrador/:idBorrador/informacionConceptoFacturaPt'),
    PortugalNuevoTramiteInformacionConceptoFactura: makeRoutePath('api/Tramites/informacionConceptoFacturaPt/:idBorrador'),
    PortugalNuevoBorradorInformacionConceptoFactura: makeRoutePath('api/Tramites/borrador/informacionConceptoFacturaPt'),
    // Emision factura Portugal
    PortugalDetalleRetrasoEmisionFactura: makeRoutePath('api/Tramites/retrasoEmisionFacturaPt/:codTramite'),
    PortugalValidacionRetrasoEmisionFactura: makeRoutePath('api/Tramites/validacion/retrasoEmisionFacturaPt/Cups/:cups'),
    PortugalDetalleBorradorRetrasoEmisionFactura: makeRoutePath('api/Tramites/borrador/:idBorrador/retrasoEmisionFacturaPt'),
    PortugalNuevoTramiteRetrasoEmisionFactura: makeRoutePath('api/Tramites/retrasoEmisionFacturaPt/:idBorrador'),
    PortugalNuevoBorradorRetrasoEmisionFactura: makeRoutePath('api/Tramites/borrador/retrasoEmisionFacturaPt'),
    // Discrepancia Medida
    ValidacionDiscrepanciaMedidaFactura: makeRoutePath('api/Tramites/validacion/discrepanciasMedidaFacturaEmitidas/Cups/:cups'),
    NuevoBorradorDiscrepanciaMedidaFactura: makeRoutePath('api/Tramites/borrador/discrepanciasMedidaFacturaEmitidas'),
    DetalleBorradorDiscrepanciaMedidaFactura: makeRoutePath('api/Tramites/borrador/:idBorrador/discrepanciasMedidaFacturaEmitidas'),
    NuevoTramiteDiscrepanciaMedidaFactura: makeRoutePath('api/Tramites/discrepanciasMedidaFacturaEmitidas/:idBorrador'),
    DetalleTramiteDiscrepanciaMedidaFactura: makeRoutePath('api/Tramites/discrepanciasMedidaFacturaEmitidas/:codTramite'),
    // Discrepancias Potencias Facturas Emitidas
    DetalleDiscrepanciasPotenciasEmitidas: makeRoutePath('api/Tramites/discrepanciasPotenciasEmitidas/:codTramite'),
    ValidacionDiscrepanciasPotenciasEmitidas: makeRoutePath('api/Tramites/validacion/discrepanciasPotenciasEmitidas/Cups/:cups'),
    DetalleBorradorDiscrepanciasPotenciasEmitidas: makeRoutePath('api/Tramites/borrador/:idBorrador/discrepanciasPotenciasEmitidas'),
    NuevoTramiteDiscrepanciasPotenciasEmitidas: makeRoutePath('api/Tramites/discrepanciasPotenciasEmitidas/:idBorrador'),
    NuevoBorradorDiscrepanciasPotenciasEmitidas: makeRoutePath('api/Tramites/borrador/discrepanciasPotenciasEmitidas'),
    // Discrepancias Potencias Facturas Emitidas en Portugal
    PortugalDetalleDiscrepanciasPotenciasEmitidas: makeRoutePath('api/Tramites/discrepanciasPotenciasEmitidasPt/:codTramite'),
    PortugalValidacionDiscrepanciasPotenciasEmitidas: makeRoutePath('api/Tramites/validacion/discrepanciasPotenciasEmitidasPt/Cups/:cups'),
    PortugalDetalleBorradorDiscrepanciasPotenciasEmitidas: makeRoutePath(
      'api/Tramites/borrador/:idBorrador/discrepanciasPotenciasEmitidasPt'
    ),
    PortugalNuevoTramiteDiscrepanciasPotenciasEmitidas: makeRoutePath('api/Tramites/discrepanciasPotenciasEmitidasPt/:idBorrador'),
    PortugalNuevoBorradorDiscrepanciasPotenciasEmitidas: makeRoutePath('api/Tramites/borrador/discrepanciasPotenciasEmitidasPt'),
    // Discrepancia en otros conceptos de facturas emitidas
    DetalleDiscrepanciaOtroConceptoFactura: makeRoutePath('api/Tramites/discrepanciaConceptoFactura/:codTramite'),
    ValidacionInformacionDiscrepanciaOtroConceptoFactura: makeRoutePath('api/Tramites/validacion/discrepanciaConceptoFactura/Cups/:cups'),
    DetalleBorradorDiscrepanciaOtroConceptoFactura: makeRoutePath('api/Tramites/borrador/:idBorrador/discrepanciaConceptoFactura'),
    NuevoTramiteDiscrepanciaOtroConceptoFactura: makeRoutePath('api/Tramites/discrepanciaConceptoFactura/:idBorrador'),
    NuevoBorradorDiscrepanciaOtroConceptoFactura: makeRoutePath('api/Tramites/borrador/discrepanciaConceptoFactura'),
    // Incidencia con fichero de medidas
    ValidacionIncidenciaFicheroMedidas: makeRoutePath('api/Tramites/validacion/incidencia/Cups/:cups'),
    NuevoBorradorIncidenciaFicheroMedidas: makeRoutePath('api/Tramites/borrador/incidencia'),
    DetalleBorradorIncidenciaFicheroMedidas: makeRoutePath('api/Tramites/borrador/:idBorrador/incidencia'),
    NuevoTramiteIncidenciaFicheroMedidas: makeRoutePath('api/Tramites/incidencia/:idBorrador'),
    DetalleIncidenciaFicheroMedidas: makeRoutePath('api/Tramites/incidencia/:codTramite'),
    // Incidencia con fichero de medidas
    PortugalValidacionIncidenciaFicheroMedidas: makeRoutePath('api/Tramites/validacion/incidenciaPt/Cups/:cups'),
    PortugalNuevoBorradorIncidenciaFicheroMedidas: makeRoutePath('api/Tramites/borrador/incidenciaPt'),
    PortugalDetalleBorradorIncidenciaFicheroMedidas: makeRoutePath('api/Tramites/borrador/:idBorrador/incidenciaPt'),
    PortugalNuevoTramiteIncidenciaFicheroMedidas: makeRoutePath('api/Tramites/incidenciaPt/:idBorrador'),
    PortugalDetalleIncidenciaFicheroMedidas: makeRoutePath('api/Tramites/incidenciaPt/:codTramite'),
    // cambio de contacto de facturación Portugal
    PortugalValidacionCambioContactoFacturacion: makeRoutePath('api/Tramites/validacion/contactoFacturacionPt/Cups/:cups'),
    PortugalNuevoBorradorCambioContactoFacturacion: makeRoutePath('api/Tramites/borrador/contactoFacturacionPt'),
    PortugalDetalleBorradorCambioContactoFacturacion: makeRoutePath('api/Tramites/borrador/:idBorrador/contactoFacturacionPt'),
    PortugalNuevoTramiteCambioContactoFacturacion: makeRoutePath('api/Tramites/contactoFacturacionPt/:idBorrador'),
    PortugalDetalleCambioContactoFacturacion: makeRoutePath('api/Tramites/contactoFacturacionPt/:codTramite'),
    // Alta o modificacion de autoconsumo
    DetalleAltaModificacionAutoconsumo: makeRoutePath('api/Tramites/autoconsumo/:codTramite'),
    ValidacionAltaModificacionAutoconsumo: makeRoutePath('api/Tramites/validacion/autoconsumo/Cups/:cups'),
    DetalleBorradorAltaModificacionAutoconsumo: makeRoutePath('api/Tramites/borrador/:idBorrador/autoconsumo'),
    NuevoTramiteAltaModificacionAutoconsumo: makeRoutePath('api/Tramites/autoconsumo/:idBorrador'),
    NuevoBorradorAltaModificacionAutoconsumo: makeRoutePath('api/Tramites/borrador/autoconsumo'),
    // Solicitud baja
    ValidacionSolicitudBaja: makeRoutePath('api/Tramites/validacion/solicitudBaja/Cups/:cups'),
    NuevoBorradorSolicitudBaja: makeRoutePath('api/Tramites/borrador/solicitudBaja'),
    DetalleBorradorSolicitudBaja: makeRoutePath('api/Tramites/borrador/:idBorrador/solicitudBaja'),
    NuevoTramiteSolicitudBaja: makeRoutePath('api/Tramites/solicitudBaja/:idBorrador'),
    DetalleSolicitudBaja: makeRoutePath('api/Tramites/solicitudBaja/:codTramite'),
    DescargarDocumentoSolicitudBajaCeseActividad: makeRoutePath('api/Tramites/borrador/:idBorrador/solicitudBaja/ceseActividad/pdf'),
    DescargarDocumentoSolicitudBajaFinSuministro: makeRoutePath('api/Tramites/borrador/:idBorrador/solicitudBaja/finSuministro/pdf'),
    // Solicitud baja en Portugal
    PortugalValidacionSolicitudBaja: makeRoutePath('api/Tramites/validacion/solicitudBajaPt/Cups/:cups'),
    PortugalNuevoBorradorSolicitudBaja: makeRoutePath('api/Tramites/borrador/solicitudBajaPt'),
    PortugalDetalleBorradorSolicitudBaja: makeRoutePath('api/Tramites/borrador/:idBorrador/solicitudBajaPt'),
    PortugalNuevoTramiteSolicitudBaja: makeRoutePath('api/Tramites/solicitudBajaPt/:idBorrador'),
    PortugalDetalleSolicitudBaja: makeRoutePath('api/Tramites/solicitudBajaPt/:codTramite'),
    // Retraso de emisión de facturas
    DetalleRetrasoEmisionFactura: makeRoutePath('api/Tramites/retrasoEmisionFactura/:codTramite'),
    ValidacionRetrasoEmisionFactura: makeRoutePath('api/Tramites/validacion/retrasoEmisionFactura/Cups/:cups'),
    DetalleBorradorRetrasoEmisionFactura: makeRoutePath('api/Tramites/borrador/:idBorrador/retrasoEmisionFactura'),
    NuevoTramiteRetrasoEmisionFactura: makeRoutePath('api/Tramites/retrasoEmisionFactura/:idBorrador'),
    NuevoBorradorRetrasoEmisionFactura: makeRoutePath('api/Tramites/borrador/retrasoEmisionFactura'),
    // Cambio de cuenta bancaria
    DetalleCambioCuentaBancaria: makeRoutePath('api/Tramites/cambioCuentaBancaria/:codTramite'),
    ValidacionCambioCuentaBancaria: makeRoutePath('api/Tramites/validacion/cambioCuentaBancaria/Cups/:cups'),
    DetalleBorradorCambioCuentaBancaria: makeRoutePath('api/Tramites/borrador/:idBorrador/cambioCuentaBancaria'),
    NuevoTramiteCambioCuentaBancaria: makeRoutePath('api/Tramites/cambioCuentaBancaria/:idBorrador'),
    NuevoBorradorCambioCuentaBancaria: makeRoutePath('api/Tramites/borrador/cambioCuentaBancaria'),
    // Cambio de cuenta bancaria
    PortugalDetalleCambioCuentaBancaria: makeRoutePath('api/Tramites/cambioCuentaBancariaPt/:codTramite'),
    PortugalValidacionCambioCuentaBancaria: makeRoutePath('api/Tramites/validacion/cambioCuentaBancariaPt/Cups/:cups'),
    PortugalDetalleBorradorCambioCuentaBancaria: makeRoutePath('api/Tramites/borrador/:idBorrador/cambioCuentaBancariaPt'),
    PortugalNuevoTramiteCambioCuentaBancaria: makeRoutePath('api/Tramites/cambioCuentaBancariaPt/:idBorrador'),
    PortugalNuevoBorradorCambioCuentaBancaria: makeRoutePath('api/Tramites/borrador/cambioCuentaBancariaPt'),
    // Cambio de titular Portugal
    PortugalDetalleCambioTitular: makeRoutePath('api/Tramites/cambioTitularPt/:codTramite'),
    PortugalValidacionCambioTitular: makeRoutePath('api/Tramites/validacion/cambioTitularPt/Cups/:cups'),
    PortugalDetalleBorradorCambioTitular: makeRoutePath('api/Tramites/borrador/:idBorrador/cambioTitularPt'),
    PortugalNuevoTramiteCambioTitular: makeRoutePath('api/Tramites/cambioTitularPt/:idBorrador'),
    PortugalNuevoBorradorCambioTitular: makeRoutePath('api/Tramites/borrador/cambioTitularPt'),
    // Cambio de titular
    DetalleCambioTitular: makeRoutePath('api/Tramites/cambioTitular/:codTramite'),
    ValidacionCambioTitular: makeRoutePath('api/Tramites/validacion/cambioTitular/Cups/:cups'),
    DetalleBorradorCambioTitular: makeRoutePath('api/Tramites/borrador/:idBorrador/cambioTitular'),
    NuevoTramiteCambioTitular: makeRoutePath('api/Tramites/cambioTitular/:idBorrador'),
    NuevoBorradorCambioTitular: makeRoutePath('api/Tramites/borrador/cambioTitular'),
    PdfSinSubrogracionCambioTitular: makeRoutePath('api/Tramites/borrador/:idBorrador/cambioTitular/sinSubrogracion/pdf'),
    PdfConSubrogracionCambioTitular: makeRoutePath('api/Tramites/borrador/:idBorrador/cambioTitular/conSubrogracion/pdf'),
    // Lectura de contador
    PortugalValidacionLecturaContador: makeRoutePath('api/Tramites/validacion/lecturaContadorPt/Cups/:cups'),
    PortugalNuevoBorradorLecturaContador: makeRoutePath('api/Tramites/borrador/lecturaContadorPt'),
    PortugalDetalleBorradorLecturaContador: makeRoutePath('api/Tramites/borrador/:idBorrador/lecturaContadorPt'),
    PortugalNuevoTramiteLecturaContador: makeRoutePath('api/Tramites/lecturaContadorPt/:idBorrador'),
    PortugalDetalleLecturaContador: makeRoutePath('api/Tramites/lecturaContadorPt/:codTramite'),
  },
  Facturas: {
    Facturas: makeRoutePath('api/Facturas/facturas'),
    Factura: makeRoutePath('api/Facturas/factura/:numFactura'),
    SolicitudInformeFactura: makeRoutePath('api/Facturas/facturacion/solicitud'),
    ListadoInformeFacturacion: makeRoutePath('api/Facturas/facturacion'),
    DescargaFicheroFacturacion: makeRoutePath('api/Facturas/facturacion/file/:idPeticion'),
  },
  Notificaciones: {
    Listado: makeRoutePath('api/Notificaciones/listado/:path'),
    Resumen: makeRoutePath('api/Notificaciones/resumen'),
    MarcarTodasComoLeidas: makeRoutePath('api/Notificaciones/leidasTodas'),
    MarcarUnaComoLeida: makeRoutePath('api/Notificaciones/marcarLeida/:notificationId'),
    Archivar: makeRoutePath('api/Notificaciones/marcarArchivar/:notificationId'),
    ArchivarTodas: makeRoutePath('api/Notificaciones/marcarArchivarTodas'),
    Desarchivar: makeRoutePath('api/Notificaciones/desArchivar/:notificationId'),
    ListadoAlertasActivas: makeRoutePath('api/Notificaciones/listado/alertas/activos'),
    DesactivarAlerta: makeRoutePath('api/Notificaciones/desactivarAlerta/:idAlerta'),
    CrearAlerta: makeRoutePath('api/Notificaciones/alertaUsuario'),
    ModificarAlerta: makeRoutePath('api/Notificaciones/updateAlerta/:idAlerta'),
    DetalleAlerta: makeRoutePath('api/Notificaciones/alertaUsuario/:idAlerta'),
    AvisosAcciona: makeRoutePath('api/Notificaciones/avisosAcciona'),
    ContenidoAvisoAcciona: makeRoutePath('api/Notificaciones/aviso/contenido/:guidAviso'),
    DocumentoAvisoAcciona: makeRoutePath('api/Notificaciones/aviso/contenido/documento/:urlDocumento'),
    PromocionesAcciona: makeRoutePath('api/Notificaciones/promocionesAcciona'),
  },
  Consumo: {
    // Acumulado
    AcumuladoDiario: makeRoutePath('api/MedidasConsumo/acumulado/diario'),
    AcumuladoMensual: makeRoutePath('api/MedidasConsumo/acumulado/mensual'),
    AcumuladoAnual: makeRoutePath('api/MedidasConsumo/acumulado/anual'),
    AcumuladoExcelDiario: makeRoutePath('api/MedidasConsumo/acumulado/diario/excel'),
    AcumuladoExcelMensual: makeRoutePath('api/MedidasConsumo/acumulado/mensual/excel'),
    AcumuladoExcelAnual: makeRoutePath('api/MedidasConsumo/acumulado/anual/excel'),
    // Comparativa
    ComparativaDiaria: makeRoutePath('api/MedidasConsumo/diario'),
    ComparativaMensual: makeRoutePath('api/MedidasConsumo/mensual'),
    ComparativaAnual: makeRoutePath('api/MedidasConsumo/anual'),
    ComparativaExcelDiaria: makeRoutePath('api/MedidasConsumo/diario/excel'),
    ComparativaExcelMensual: makeRoutePath('api/MedidasConsumo/mensual/excel'),
    ComparativaExcelAnual: makeRoutePath('api/MedidasConsumo/anual/excel'),
    ComparativaDatos: makeRoutePath('api/MedidasConsumo/:path'),
    ComparativaExcel: makeRoutePath('api/MedidasConsumo/:path/excel'),
    // Mapa
    Geolocalizacion: makeRoutePath('api/MedidasConsumo/geolocalizacion'),
    // Listado de peticiones realizadas
    ListadoPeticiones: makeRoutePath('api/MedidasConsumo/medidas'),
    DescargarFicheroPeticion: makeRoutePath('api/MedidasConsumo/medidas/file/:idPeticio'),
    SolicitudDescargaMedidas: makeRoutePath('api/MedidasConsumo/medidas/solicitud'),
    Gasto: makeRoutePath('api/MedidasConsumo/gasto'),
  },
  ConsumoInformes: {
    // Climatización
    ClimateDiario: makeRoutePath('api/RehabEnergetica/datosConsumo/diario'),
    ClimateMensual: makeRoutePath('api/RehabEnergetica/datosConsumo/mensual'),
    ClimateExcelDiario: makeRoutePath('api/RehabEnergetica/datosConsumo/diario/excel'),
    ClimateExcelMensual: makeRoutePath('api/RehabEnergetica/datosConsumo/mensual/excel'),
    // ACS
    AcsDiario: makeRoutePath('api/RehabEnergetica/datosConsumo/diario'),
    AcsMensual: makeRoutePath('api/RehabEnergetica/datosConsumo/mensual'),
    AcsExcelDiario: makeRoutePath('api/RehabEnergetica/datosConsumo/diario/excel'),
    AcsExcelMensual: makeRoutePath('api/RehabEnergetica/datosConsumo/mensual/excel'),
    // Viviendas
    ViviendasClimate: makeRoutePath('api/RehabEnergetica/viviendas/climatizacion/user'),
    ViviendasAcs: makeRoutePath('api/RehabEnergetica/viviendas/acs/user'),
    // Habitaciones
    HabitacionesClimate: makeRoutePath('api/RehabEnergetica/habitaciones/climatizacion/user'),
    HabitacionesAcs: makeRoutePath('api/RehabEnergetica/habitaciones/acs/user'),
    // Informes
    InformesUser: makeRoutePath('api/RehabEnergetica/informes/user'),
    UnloadReport: makeRoutePath('api/RehabEnergetica/informes/:codigo/descarga'),
  },
  Sostenibilidad: {
    DatosHuellaCarbono: makeRoutePath('api/Sostenibilidad/huella'),
    DatosHuellaCarbonoPdf: makeRoutePath('api/Sostenibilidad/huella/pdf'),
    FactoresConversion: makeRoutePath('api/Sostenibilidad/factoresConversion'),
    GarantiaOrigen: makeRoutePath('api/Sostenibilidad/garantiaOrigen'),
    GarantiaOrigenPdf: makeRoutePath('api/Sostenibilidad/garantiaOrigen/pdf'),
    Certificado: makeRoutePath('api/Sostenibilidad/certificado/:codCertificado'),
  },
};
